import { fetchMarketPrice } from "actions/balance";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import marketPriceSelector from "selectors/marketPrice";
import marketPriceStatusSelector from "selectors/marketPriceStatus";
import { centHundredthsToString } from "utils/moneyFormat";
import HomeCard from "./HomeCard";

const MarketPriceCard: React.FC = () => {
    const marketPrice = useSelector(marketPriceSelector);
    const status = useSelector(marketPriceStatusSelector);
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(fetchMarketPrice());
    }, [dispatch]);

    return (
        <HomeCard>
            <h5 className="card-title">Market Price</h5>
            {marketPrice && (
                <p className="card-text">
                    {centHundredthsToString(marketPrice.price_cent_hundredths)}{" "}
                    per minute
                </p>
            )}
            {!marketPrice &&
                (status === "error" ? (
                    <p>Loading...</p>
                ) : (
                    <p>Error, refresh to try again.</p>
                ))}
            <Link
                to="/home/dashboard/balance/minutes/sell"
                className="card-link"
            >
                Sell Minutes
            </Link>
            <Link
                to="/home/dashboard/balance/minutes/order"
                className="card-link"
            >
                Buy Minutes
            </Link>
        </HomeCard>
    );
};

export default MarketPriceCard;
